import * as types from "../../../_constants/types";

export default (state = null, action) => {
    switch (action.type) {
        case types.AUTH_TOKEN_LOAD:
            return (state = action.data);

        case types.RESET:
        case types.AUTH_TOKEN_RESET:
            return null;

        default:
            return state;
    }
};
